import styled from 'styled-components';
import theme from 'styles/theme';

export const StyledDatePickerWrapper = styled.div`
  width: 100%;

  .MuiOutlinedInput-root {
    &:hover fieldset {
      border-color: ${theme.colors.success};
      box-shadow: 0px 0px 2px 0px ${theme.colors.success};
    }

    &.Mui-focused fieldset {
      border-color: ${theme.colors.success};
      box-shadow: 0px 0px 2px 0px ${theme.colors.success};
    }
  }
`;
